import React, { createContext, useContext, useState } from 'react'

interface ModalAddressContextData {
  showModalAddress: boolean
  setShowModalAddress: React.Dispatch<React.SetStateAction<boolean>>
  setFields: React.Dispatch<React.SetStateAction<any>>
  fields: any
}

export const ModalAddressContext = createContext<ModalAddressContextData>(
  {} as ModalAddressContextData
)

export const ModalAddressProvider: React.FC = ({ children }) => {
  const [showModalAddress, setShowModalAddress] = useState(false)
  const [fields, setFields] = useState<any>({})

  return (
    <ModalAddressContext.Provider
      value={{
        showModalAddress,
        setShowModalAddress,
        setFields,
        fields
      }}
    >
      {children}
    </ModalAddressContext.Provider>
  )
}

export function useModalAddressContext() {
  return useContext(ModalAddressContext)
}
